<template>
  <div class="modal fade" id="ErrorMsgModal" data-backdrop="static">
    <div class="modal-dialog error-modal-wrapper">
      <div class="modal-content expiry-modal-content">
        <div class="modal-header">
            <section>
              <div class="col-xs-12 p-18 d-flex align-items-center justify-content-between header-wrapper">
                <div class="modal-header-title fw-600 font-20">
                  <p v-if="failureType" class="first-card-title update-failed m-0">{{failureType}}</p>
                <p v-else class="first-card-title update-failed m-0">{{$t('updateFailed')}}</p>
                </div>
                <img
                  class="pr-5 cursor-pointer"
                  src="/static/images/icons/emergo_modal_close.svg"
                  @click="closePopup"
                />
              </div>
            </section>
        </div>
        <div class="modal-body p-0">
            <div class="row">
              <div class="col-xs-12">
                <div class="col-xs-12 pl-18 pr-18 mb-30">
                  <p class="error-message" v-html="errorMessage"></p>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer mt-30">
            <section>
              <div class="col-xs-12 p-0 d-flex justify-content-end col-gap-16">
                <button
                  type="button"
                  class="btn emergo-btn emergo-primary-button"
                  @click="closePopup"
                >
                OK
                </button>
              </div>
            </section>
          </div>
        <!-- <div class="modal-header">
          <div class="card text-center">
            <div class="card-body">
            <img src="../../../public/static/images/icons/expiry.svg" class="expiry_logo card-img-top" />
              <div class="card-title">
                <p v-if="failureType" class="first-card-title update-failed">{{failureType}}</p>
                <p v-else class="first-card-title update-failed">{{$t('updateFailed')}}</p>
              </div>
              <div class="card-text">
                <p class="error-message" v-html="errorMessage"></p>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-12 ok-btn">
                <button
                 :class="[isTeamMember ? 'emergo-new-blue-button' : 'btn btn-block emergo-blue-button']"
                  @click="closePopup"
                >OK</button>
              </div>
            </div>
          </div>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';

export default {
  props: ['errorMessage', 'failureType', 'isTeamMember'],
  data() {
    return {

    };
  },
  methods: {
    closePopup() {
      $('#ErrorMsgModal').modal('hide');
    },
  },

};
</script>

<style scoped>
.pl-18 {
  padding-left: 18px;
}

.pr-18 {
  padding-left: 18px;
}
.modal-open .modal {
  overflow: hidden;
}
.modal .modal-dialog .modal-content {
  border-radius: 10px;
}
.modal .modal-dialog .modal-content .modal-header {
  border-bottom: none;
  background-color: #ffffff;
  padding: 0px;
  border-radius: 8px;
  color: #1a1a1a;
}
.card .card-body .card-title p.first-card-title {
  font-size: 25px;
  padding-top: 20px;
  color: rgba(0, 0, 0, 0.7);
  font-weight: 500;
}
img.expiry_logo.card-img-top {
    width: 50px;
    height: 50px;
}
.error-message {
  padding-bottom: 20px;
  color: #333333;
  line-height: 22px;
  font-size: 18px;
  font-weight: 400;
}
.ok-btn {
  width: 50%;
  margin: auto;
  float: initial;
}

.modal-dialog{
  margin: 20px auto;;
}

.emergo-new-blue-button {
  background-color: #0b3c61;
  border: 1px solid #0b3c61;
  border-radius: 5px;
  color: #F2F2F2;
  font-weight: 600;
  font-size: 18px;
  font-family: 'Open Sans';
  line-height: 25px;
  padding: 6px 15px;
}

.modal-header-title {
  line-height: 27px;
  color: #1a1a1a;
}

.header-wrapper {
  border-bottom: 1px solid #d3d3d3;
  margin-bottom: 24px;
}

.modal-footer {
  background-color: #fafaf9;
  border-top: none;
  border-radius: 8px;
  padding: 16px;
}

@media screen and (min-width: 768px) {
  .error-modal-wrapper{
    width: 500px;
  }
}
</style>
